const API_BASE = process.env.REACT_APP_API_URL || '/api';

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

function getSessionId() {
  let sid = sessionStorage.getItem('session_id');
  if (!sid) {
    sid = Math.random().toString(36).substr(2) + Date.now().toString(36);
    sessionStorage.setItem('session_id', sid);
  }
  return sid;
}

export const api = {
  chat: (question, image = null) =>
    fetch(`${API_BASE}/chat.php`, {
      method: 'POST', headers: getHeaders(),
      body: JSON.stringify({ question, image, session_id: getSessionId() })
    }).then(r => r.json()),

  login: (email, password) =>
    fetch(`${API_BASE}/auth.php?action=login`, {
      method: 'POST', headers: getHeaders(),
      body: JSON.stringify({ email, password })
    }).then(r => r.json()),

  register: (name, email, password) =>
    fetch(`${API_BASE}/auth.php?action=register`, {
      method: 'POST', headers: getHeaders(),
      body: JSON.stringify({ name, email, password })
    }).then(r => r.json()),

  me: () => fetch(`${API_BASE}/auth.php?action=me`, { headers: getHeaders() }).then(r => r.json()),

  plans: () => fetch(`${API_BASE}/plans.php`).then(r => r.json()),

  createOrder: (planId, gateway, billingCycle) =>
    fetch(`${API_BASE}/payment.php?action=create-order`, {
      method: 'POST', headers: getHeaders(),
      body: JSON.stringify({ plan_id: planId, gateway, billing_cycle: billingCycle })
    }).then(r => r.json()),

  verifyPayment: (paymentId, planId, gateway) =>
    fetch(`${API_BASE}/payment.php?action=verify`, {
      method: 'POST', headers: getHeaders(),
      body: JSON.stringify({ payment_id: paymentId, plan_id: planId, gateway })
    }).then(r => r.json()),

  adminLogin: (email, password) =>
    fetch(`${API_BASE}/auth.php?action=admin-login`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    }).then(r => r.json()),

  admin: (action, method = 'GET', body = null, params = '') => {
    const token = localStorage.getItem('adminToken');
    return fetch(`${API_BASE}/admin.php?action=${action}${params}`, {
      method,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: body ? JSON.stringify(body) : null,
    }).then(r => r.json());
  },
};

export default api;
